import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=8a153512&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
import style0 from "./Loader.vue?vue&type=style&index=0&id=8a153512&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a153512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a153512')) {
      api.createRecord('8a153512', component.options)
    } else {
      api.reload('8a153512', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=8a153512&scoped=true", function () {
      api.rerender('8a153512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Loader.vue"
export default component.exports